import { render } from "./SeriesCard.vue?vue&type=template&id=72ac7b1b&scoped=true"
import script from "./SeriesCard.vue?vue&type=script&lang=js"
export * from "./SeriesCard.vue?vue&type=script&lang=js"

import "./SeriesCard.vue?vue&type=style&index=0&id=72ac7b1b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ac7b1b"]])

export default __exports__